/* ========================================================
   PLP Size Drawer Toggle Functionality
   ======================================================== */
(function () {
  'use strict';

  function initPlpSizeToggle() {
    if (window._plpSizeToggleInitialized) return;
    window._plpSizeToggleInitialized = true;

    // Handle clicks on the size toggle button
    document.addEventListener('click', function (e) {
      const toggleBtn = e.target.closest('.plp-card-size-toggle');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();

        const card = toggleBtn.closest('.card') || toggleBtn.closest('.card-wrapper') || toggleBtn.closest('.product-card-wrapper');
        if (!card) return;

        const isCurrentlyOpen = card.classList.contains('is-sizes-open');

        // Close all other open size drawers on the page
        document.querySelectorAll('.is-sizes-open').forEach(function (openCard) {
          if (openCard !== card) {
            openCard.classList.remove('is-sizes-open');
            const otherBtn = openCard.querySelector('.plp-card-size-toggle');
            if (otherBtn) {
              otherBtn.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // Toggle this card
        if (isCurrentlyOpen) {
          card.classList.remove('is-sizes-open');
          toggleBtn.setAttribute('aria-expanded', 'false');
        } else {
          card.classList.add('is-sizes-open');
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Close when clicking outside of any card
      if (!e.target.closest('.card') && !e.target.closest('.card-wrapper') && !e.target.closest('.product-card-wrapper')) {
        document.querySelectorAll('.is-sizes-open').forEach(function (openCard) {
          openCard.classList.remove('is-sizes-open');
          const btn = openCard.querySelector('.plp-card-size-toggle');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });

    // Keyboard support for accessibility
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        const toggleBtn = e.target.closest('.plp-card-size-toggle');
        if (toggleBtn) {
          e.preventDefault();
          toggleBtn.click();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlpSizeToggle);
  } else {
    initPlpSizeToggle();
  }
})();
